// Keep errors visible across General and Translations tabs before saving.
import React from 'react';
export default function FlowFieldErrors({ errors }) {
  if (!errors.length) return null;
  return <div role="alert" className="ui negative message">
    <strong>Correct these WhatsApp Flow fields before saving.</strong>
    <ul>{errors.map(error => <li key={error}>{error}</li>)}</ul>
  </div>;
}
